import { useAsyncList as a } from "@vp/swan";
import { useState as g } from "react";
import { getSuggestedQueries as c } from "./help-center-articles-search24.js";
import { convertSuggestedQueriesResponseToComboboxItems as m } from "./help-center-articles-search9.js";
import { getSearchResultSectionTrackingData as p } from "./help-center-articles-search25.js";
const h = ({
  environment: t,
  locale: o,
  applicationName: y,
  path: r,
  track: u
}) => {
  const [n, i] = g(null);
  return {
    queryResults: a({
      async load({ filterText: e }) {
        if (!e)
          return { items: [] };
        const s = await c({
          query: e || "",
          environment: t,
          locale: o
        });
        return i(s), u(p({
          query: e,
          location: r,
          suggestedQueriesResponse: s,
          locale: o,
          env: t
        })), m(e || "", s);
      }
    }),
    querySuggestionsResponse: n
  };
};
export {
  h as useQuerySuggestions
};
//# sourceMappingURL=help-center-articles-search11.js.map
